import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { findDOMNode } from 'react-dom';
import raf from 'raf';
import NOOP from 'lodash/noop';
import getFields from '@ott/get-fields-utility';
import findActiveControl from './findActiveControl';
const ClosestParent = require('dom-helpers/query/closest');

import FirstErrorShower from '@ott/first-error-shower';

class Form extends PureComponent {
  constructor(props, ctx) {
    super(props, ctx);

    this.handleSubmit = this.handleSubmit.bind(this);

    this.state = {};
  }

  componentDidUpdate() {
    if (this._focusNextControl) {
      this._focusNextControl = false;
      this.focusNextControl();
    }
  }

  getErrors() {
    return {};
  }

  findForm() {
    this._form = findDOMNode(this);
    if (this._form.tagName !== 'FORM') {
      this._form = this._form.querySelector('form') || ClosestParent(this._form, 'form');
    }
  }

  findSubmitButton() {
    if (this._controls) {
      let submit;
      this._controls.reverse().some(el => {
        if (el.getAttribute('type') === 'submit') {
          submit = el;
          return true;
        }
        return false;
      });
      return submit;
    }
  }

  findNextControl(errors) {
    let next;
    const fieldsNames = getFields(errors).reduce((acc, field) => {
      if (field.field) {
        acc[field.field] = field;
      }
      return acc;
    }, {});

    let activeElement;
    try {
      activeElement = document.activeElement;
    } catch (e) {
      // hi edge
    }
    const { controls, active } = findActiveControl(activeElement, this._controls);

    if (active && fieldsNames[active && active.getAttribute('name')]) {
      return active;
    }

    controls.some(el => {
      const name = el.getAttribute('name');
      if (fieldsNames[name]) {
        next = el;
        return true;
      }
      return false;
    });
    return next;
  }

  focusNextControl() {
    this.findForm();
    if (!this._form) {
      console.error('BaseForm: no form found on focusNext call, halted'); // eslint-disable-line no-console,max-len
      return;
    }
    let next;
    let submit;
    this._controls = Array.from(this._form.elements);
    const errors = this.getErrors();
    const isValid = Object.keys(errors).length === 0;

    const forceNext = this.props.forceNextFocus;

    raf(() => {
      if (forceNext) {
        let activeControlIdx = this._controls.indexOf(document.activeElement);

        if (!~activeControlIdx) {
          activeControlIdx =
            findActiveControl(document.activeElement, this._controls).activeIdx - 1;
        }

        if (activeControlIdx < this._controls.length - 1) {
          next = this._controls[activeControlIdx + 1];
          if (next && next.focus) {
            next.focus();
          }
        } else {
          submit = this.findSubmitButton();
          if (submit && submit.focus) {
            submit.focus();
          }
        }
      } else {
        if (isValid) {
          submit = this.findSubmitButton();
          if (submit && submit.focus) {
            submit.focus();
          }
        } else {
          next = this.findNextControl(errors);
          if (next && next.focus) {
            next.focus();
          }
        }
      }
    });
  }

  submit() {
    return this.props.handleSubmit(...arguments);
  }

  handleSubmit(e) {
    if (e && typeof e.preventDefault === 'function') {
      e.preventDefault();
    }
    this.setState({
      submitTime: new Date().getTime(),
    });
    this.submit(e);
  }

  renderFirstErrorShower() {
    return (
      <FirstErrorShower
        errors={this.props.errors}
        show={this.props.submitFailed}
        time={this.state.submitTime}
        container={this}
      />
    );
  }
  render() {
    return null;
  }
}

const controlShape = {
  name: PropTypes.string,
  defaultChecked: PropTypes.bool,
  defaultValue: PropTypes.any,
  value: PropTypes.any,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onDragStart: PropTypes.func,
  onDrop: PropTypes.func,
  onFocus: PropTypes.func,
  onUpdate: PropTypes.func,
  valid: PropTypes.bool,
  invalid: PropTypes.bool,
  checked: PropTypes.bool,
  dirty: PropTypes.bool,
  pristine: PropTypes.bool,
  error: PropTypes.any,
  active: PropTypes.bool,
  touched: PropTypes.bool,
  visited: PropTypes.bool,
};

const _control = PropTypes.shape(controlShape);

const control = PropTypes.oneOfType([_control, PropTypes.arrayOf(_control)]);

Form.propTypes = Object.assign({
  asyncValidate: PropTypes.func,
  asyncValidating: PropTypes.bool,
  destroyForm: PropTypes.func,
  dirty: PropTypes.bool,
  dispatch: PropTypes.func,
  error: PropTypes.string,
  errors: PropTypes.object,
  fields: PropTypes.objectOf(control),
  formKey: PropTypes.string,
  initializeForm: PropTypes.func,
  invalid: PropTypes.bool,
  pristine: PropTypes.bool,
  readonly: PropTypes.bool,
  resetForm: PropTypes.func,
  submitFailed: PropTypes.bool,
  submitting: PropTypes.bool,
  total: PropTypes.object,
  touch: PropTypes.func,
  touchAll: PropTypes.func,
  untouch: PropTypes.func,
  untouchAll: PropTypes.func,
  valid: PropTypes.bool,
  values: PropTypes.object,
  handleSubmit: PropTypes.func,
});

Form.defaultProps = {
  handleSubmit: NOOP,
};

export default Form;
